import React, { useState, useEffect } from 'react'
import usePlantDetailsStyles from './styles'
import { Box } from '@mui/material'
import '../../addplant-style.scss'
import Grid from '@mui/material/Grid'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CustomTextField from '../../../../components/CustomTextField/CustomTextField'
import { get } from 'lodash'
import DropDown from '../../../../components/DropDown/DropDown'
import Fileupload from '../../../../components/Fileupload/Fileupload'
import CurrencySelect from '../CurrencySelect/CurrencySelect'
import moment from 'moment-timezone'
import TimeZoneSelect from '../TimeZoneSelect/TimeZoneSelect'

const PlantDetails = ({ formik }) => {
  const classes = usePlantDetailsStyles()
  const [currencies, setCurrencies] = useState([])
  const [selectedCurrency, setSelectedCurrency] = useState('')
  const [timeZones, setTimeZones] = useState([])
  const [selectedTimeZone, setSelectedTimeZone] = useState('')

  useEffect(() => {
    fetch('https://open.er-api.com/v6/latest')
      .then((response) => response.json())
      .then((data) => {
        const fetchedCurrencies = Object.keys(data.rates).map((code) => ({
          code,
          name: getCurrencyName(code),
        }))
        setCurrencies(fetchedCurrencies)
      })
      .catch((error) => console.error('Error fetching currency data:', error))
  }, [])

  useEffect(() => {
    const allTimeZones = moment.tz.names()
    setTimeZones(allTimeZones)
  }, [])

  const handleTimeZoneChange = (event) => {
    setSelectedTimeZone(event.target.value)
    formik.setFieldValue(`plantDetails.plantTimeZone`, event.target.value)
  }

  console.log(timeZones, 'timeZones')

  const getCurrencyName = (code) => {
    // You can implement a function to get the currency name based on the code.
    // This can be done using a currency data library or a custom mapping.
    // For this example, I'll use a simple mapping for demonstration purposes.
    const currencyNames = {
      USD: 'United States Dollar',
      EUR: 'Euro',
      GBP: 'British Pound Sterling',
      // Add more currency names as needed
    }

    return currencyNames[code] || code
  }

  const handleCurrencyChange = (event) => {
    setSelectedCurrency(event.target.value)
    formik.setFieldValue(`plantDetails.currency`, event.target.value)
  }

  const FieldError = (error, helperText) => {
    return (
      error &&
      helperText && (
        <div style={{ fontSize: 12, color: 'red', marginLeft: '20px' }}>
          {helperText}
        </div>
      )
    )
  }

  return (
    <div className={classes.root}>
      <div className="ptb_20">
        <Box
          sx={{
            '& .MuiTextField-root': { width: '100%' },
          }}
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={2} className="mb_20">
            <Grid item xs={12} md={4}>
              <div className=" textfield">
                <CustomTextField
                  label="Plant Name"
                  id="filled-size-small"
                  value={formik.values.plantDetails.plantName}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.plantName`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.plantName}
                  helperText={
                    get(formik, `touched.plantDetails.plantName`) &&
                    get(formik, `errors.plantDetails.plantName`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className=" textfield">
                <CustomTextField
                  label="Project Code"
                  id="filled-size-small"
                  value={formik.values.plantDetails.projectCode}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.projectCode`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.projectCode}
                  helperText={
                    get(formik, `touched.plantDetails.projectCode`) &&
                    get(formik, `errors.plantDetails.projectCode`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={3.2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Commission Date"
                  format="DD-MM-YYYY"
                  value={formik.values.plantDetails.commissionDate}
                  onChange={(value) =>
                    formik.setFieldValue(`plantDetails.commissionDate`, value)
                  }
                />
              </LocalizationProvider>
              {FieldError(
                formik.errors?.plantDetails?.commissionDate,
                get(formik, `touched.plantDetails.commissionDate`) &&
                  get(formik, `errors.plantDetails.commissionDate`)
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <div className=" textfield">
                <CustomTextField
                  label="Plant Location"
                  id="filled-size-small"
                  value={formik.values.plantDetails.plantLocation}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.plantLocation`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.plantLocation}
                  helperText={
                    get(formik, `touched.plantDetails.plantLocation`) &&
                    get(formik, `errors.plantDetails.plantLocation`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={2}>
              <div className=" textfield">
                <CustomTextField
                  label="Industry Type"
                  id="filled-size-small"
                  value={formik.values.plantDetails.industryType}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.industryType`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.industryType}
                  helperText={
                    get(formik, `touched.plantDetails.industryType`) &&
                    get(formik, `errors.plantDetails.industryType`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={2}>
              <div className=" textfield">
                <DropDown
                  label="Grid Status"
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={formik.values.plantDetails.gridStatus}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.gridStatus`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.gridStatus}
                  helperText={
                    get(formik, `touched.plantDetails.gridStatus`) &&
                    get(formik, `errors.plantDetails.gridStatus`)
                  }
                  MenuData={['Ongrid', 'Offgrid']}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={3.2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Completion Date"
                  format="DD-MM-YYYY"
                  value={formik.values.plantDetails.completionDate}
                  onChange={(value) =>
                    formik.setFieldValue(`plantDetails.completionDate`, value)
                  }
                />
              </LocalizationProvider>
              {FieldError(
                formik.errors?.plantDetails?.completionDate,
                get(formik, `touched.plantDetails.completionDate`) &&
                  get(formik, `errors.plantDetails.completionDate`)
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="textfield">
                <CustomTextField
                  Adornmenttype={true}
                  label="Plant Size"
                  Adornmentlabel="kWp"
                  Adornmentposition="end"
                  id="filled-adornment-weight"
                  value={formik.values.plantDetails.plantSize}
                  type="number"
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.plantSize`,
                      Number(value.target.value)
                    )
                  }
                  error={formik.errors?.plantDetails?.plantSize}
                  helperText={
                    get(formik, `touched.plantDetails.plantSize`) &&
                    get(formik, `errors.plantDetails.plantSize`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className=" textfield mt_m8">
                <Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <CustomTextField
                        label="Longitude"
                        id="filled-size-small"
                        value={formik.values.plantDetails.longitude}
                        onChange={(value) =>
                          formik.setFieldValue(
                            `plantDetails.longitude`,
                            Number(value.target.value)
                          )
                        }
                        type="number"
                        error={formik.errors?.plantDetails?.longitude}
                        helperText={
                          get(formik, `touched.plantDetails.longitude`) &&
                          get(formik, `errors.plantDetails.longitude`)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CustomTextField
                        label="Latitude"
                        id="filled-size-small"
                        value={formik.values.plantDetails.latitude}
                        onChange={(value) =>
                          formik.setFieldValue(
                            `plantDetails.latitude`,
                            Number(value.target.value)
                          )
                        }
                        type="number"
                        error={formik.errors?.plantDetails?.latitude}
                        helperText={
                          get(formik, `touched.plantDetails.latitude`) &&
                          get(formik, `errors.plantDetails.latitude`)
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} md={3.2}>
              <div>
                <TimeZoneSelect
                  label="Plant Time Zone"
                  timeZones={timeZones}
                  selectedTimeZone={formik.values.plantDetails.plantTimeZone}
                  onTimeZoneChange={handleTimeZoneChange}
                  formik={formik}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className=" y_n_toggle">
                <div className="contractor_access">
                  <div className="align_btw" style={{ height: '56px' }}>
                    <div className="toggle_txt">Sub. Contractor Access</div>
                    <label class="switch">
                      <input
                        type="checkbox"
                        value={formik.values.plantDetails.subContractorAccess}
                        defaultChecked={
                          formik.values.plantDetails.subContractorAccess
                        }
                        onChange={(value) =>
                          formik.setFieldValue(
                            `plantDetails.subContractorAccess`,
                            !formik.values.plantDetails.subContractorAccess
                          )
                        }
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className=" textfield">
                <Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <CustomTextField
                        Adornmenttype={true}
                        label="Tenure"
                        Adornmentlabel="Year"
                        Adornmentposition="end"
                        type="number"
                        id="filled-adornment-weight"
                        value={formik.values.plantDetails.tenure}
                        onChange={(value) =>
                          formik.setFieldValue(
                            `plantDetails.tenure`,
                            Number(value.target.value)
                          )
                        }
                        error={formik.errors?.plantDetails?.tenure}
                        helperText={
                          get(formik, `touched.plantDetails.tenure`) &&
                          get(formik, `errors.plantDetails.tenure`)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <div>
                        {currencies.length > 0 && (
                          <CurrencySelect
                            currencies={currencies}
                            label="Currency"
                            selectedCurrency={
                              formik.values.plantDetails.currency
                            }
                            onCurrencyChange={handleCurrencyChange}
                            formik={formik}
                          />
                        )}{' '}
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="mt_8 textfield">
                <Box>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={9.5}>
                      <div
                        className=" y_n_toggle"
                        style={{ marginTop: '-8px' }}
                      >
                        <div className="contractor_access">
                          <Grid
                            sx={{
                              borderRadius: '50px',
                              backgroundColor: '#fff',
                            }}
                          >
                            <Fileupload formik={formik} />
                          </Grid>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={2.5} className="align_start">
                      <div></div>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className=" textfield">
                <CustomTextField
                  label="Sim Serial Number"
                  id="filled-size-small"
                  value={formik.values.plantDetails.simSerialNumber}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.simSerialNumber`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.simSerialNumber}
                  helperText={
                    get(formik, `touched.plantDetails.simSerialNumber`) &&
                    get(formik, `errors.plantDetails.simSerialNumber`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={2}>
              <div className=" textfield">
                <DropDown
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  label="Proposal Type"
                  value={formik.values.plantDetails.proposalType?.type}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.proposalType.type`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.proposalType?.type}
                  helperText={
                    get(formik, `touched.plantDetails.proposalType.type`) &&
                    get(formik, `errors.plantDetails.proposalType.type`)
                  }
                  MenuData={['EMI', 'PPA', 'AMF']}
                />
              </div>
            </Grid>
            {formik?.values?.plantDetails?.proposalType?.type === 'PPA' ||
            formik?.values?.plantDetails?.proposalType?.type === 'AMF' ? (
              <>
                <Grid item xs={12} md={2}>
                  <div className=" textfield">
                    <CustomTextField
                      Adornmenttype={true}
                      label="Tariff Escalation"
                      Adornmentlabel="%"
                      Adornmentposition="end"
                      id="filled-adornment-weight"
                      value={
                        formik.values.plantDetails.proposalType
                          ?.tariffEscalation
                      }
                      onChange={(value) =>
                        formik.setFieldValue(
                          `plantDetails.proposalType.tariffEscalation`,
                          value.target.value
                        )
                      }
                      error={
                        formik.errors?.plantDetails?.proposalType
                          ?.tariffEscalation
                      }
                      helperText={
                        get(
                          formik,
                          `touched.plantDetails.proposalType.tariffEscalation`
                        ) &&
                        get(
                          formik,
                          `errors.plantDetails.proposalType.tariffEscalation`
                        )
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={2}>
                  <div className=" textfield">
                    <CustomTextField
                      Adornmenttype={true}
                      label="Tariff"
                      Adornmentlabel="INR"
                      Adornmentposition="end"
                      type="number"
                      value={formik.values.plantDetails.proposalType?.tariff}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `plantDetails.proposalType.tariff`,
                          Number(value.target.value) || ''
                        )
                      }
                      error={formik.errors?.plantDetails?.proposalType?.tariff}
                      helperText={
                        get(
                          formik,
                          `touched.plantDetails.proposalType.tariff`
                        ) &&
                        get(formik, `errors.plantDetails.proposalType.tariff`)
                      }
                    />
                  </div>
                </Grid>
              </>
            ) : formik?.values?.plantDetails?.proposalType?.type === 'EMI' ? (
              <>
                <Grid item xs={12} md={3}>
                  <div className=" textfield">
                    <CustomTextField
                      Adornmenttype={true}
                      label="Monthly EMI Amount"
                      Adornmentlabel="INR"
                      Adornmentposition="end"
                      v
                      value={
                        formik.values.plantDetails.proposalType
                          ?.monthlyEmiAmount
                      }
                      onChange={(value) =>
                        formik.setFieldValue(
                          `plantDetails.proposalType.monthlyEmiAmount`,
                          value.target.value
                        )
                      }
                      error={
                        formik.errors?.plantDetails?.proposalType
                          ?.monthlyEmiAmount
                      }
                      helperText={
                        get(
                          formik,
                          `touched.plantDetails.proposalType.monthlyEmiAmount`
                        ) &&
                        get(
                          formik,
                          `errors.plantDetails.proposalType.monthlyEmiAmount`
                        )
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <div className=" textfield">
                    <CustomTextField
                      Adornmenttype={true}
                      label="Monthly O&M Amount"
                      Adornmentlabel="INR"
                      Adornmentposition="end"
                      value={
                        formik.values.plantDetails.proposalType?.monthlyOMAmount
                      }
                      onChange={(value) =>
                        formik.setFieldValue(
                          `plantDetails.proposalType.monthlyOMAmount`,
                          value.target.value
                        )
                      }
                      error={
                        formik.errors?.plantDetails?.proposalType
                          ?.monthlyOMAmount
                      }
                      helperText={
                        get(
                          formik,
                          `touched.plantDetails.proposalType.monthlyOMAmount`
                        ) &&
                        get(
                          formik,
                          `errors.plantDetails.proposalType.monthlyOMAmount`
                        )
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={3.2}>
                  <div className=" textfield">
                    <CustomTextField
                      Adornmenttype={true}
                      label="Total Monthly Amount"
                      Adornmentlabel="INR"
                      Adornmentposition="end"
                      value={
                        formik.values.plantDetails.proposalType
                          ?.totalMonthlyAmount
                      }
                      onChange={(value) =>
                        formik.setFieldValue(
                          `plantDetails.proposalType.totalMonthlyAmount`,
                          value.target.value
                        )
                      }
                      error={
                        formik.errors?.plantDetails?.proposalType
                          ?.totalMonthlyAmount
                      }
                      helperText={
                        get(
                          formik,
                          `touched.plantDetails.proposalType.totalMonthlyAmount`
                        ) &&
                        get(
                          formik,
                          `errors.plantDetails.proposalType.totalMonthlyAmount`
                        )
                      }
                    />
                  </div>
                </Grid>
              </>
            ) : (
              <div></div>
            )}
            <Grid item xs={12} md={2}>
              <div className=" textfield">
                <DropDown
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  label="Plant Type"
                  value={formik.values.plantDetails.plantType}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.plantType`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.plantType}
                  helperText={
                    get(formik, `touched.plantDetails.plantType`) &&
                    get(formik, `errors.plantDetails.plantType`)
                  }
                  MenuData={['Capex', 'Opex']}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={3.2}>
              <div className=" textfield">
                <CustomTextField
                  label="Sim Network"
                  id="filled-size-small"
                  value={formik.values.plantDetails.simNetwork}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.simNetwork`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.simNetwork}
                  helperText={
                    get(formik, `touched.plantDetails.simNetwork`) &&
                    get(formik, `errors.plantDetails.simNetwork`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={2.8}>
              <div className=" textfield">
                <CustomTextField
                  label="Network Provier"
                  id="filled-size-small"
                  value={formik.values.plantDetails.networkProvier}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.networkProvier`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.networkProvier}
                  helperText={
                    get(formik, `touched.plantDetails.networkProvier`) &&
                    get(formik, `errors.plantDetails.networkProvier`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={2.8}>
              <div className=" textfield">
                <CustomTextField
                  label="Dongle Serial Number"
                  id="filled-size-small"
                  value={formik.values.plantDetails.dongleSerialNumber}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.dongleSerialNumber`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.plantDetails?.dongleSerialNumber}
                  helperText={
                    get(formik, `touched.plantDetails.dongleSerialNumber`) &&
                    get(formik, `errors.plantDetails.dongleSerialNumber`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={2.8}>
              <div className="textfield">
                <CustomTextField
                  Adornmenttype={true}
                  label="Late Payment Interest Fee"
                  Adornmentlabel="%"
                  Adornmentposition="end"
                  type="number"
                  id="filled-adornment-weight"
                  value={formik.values.plantDetails.interestRate}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.interestRate`,
                      Number(value.target.value) || 0
                    )
                  }
                  error={formik.errors?.plantDetails?.interestRate}
                  helperText={
                    get(formik, `touched.plantDetails.interestRate`) &&
                    get(formik, `errors.plantDetails.interestRate`)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={12} md={2.8}>
              <div className="textfield">
                <CustomTextField
                  label="Organization ID"
                  type="number"
                  id="filled-size-small"
                  value={formik.values.plantDetails.organizationId}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.organizationId`,
                      Number(value.target.value) || 0
                    )
                  }
                  error={formik.errors?.plantDetails?.organizationId}
                  helperText={
                    get(formik, `touched.plantDetails.organizationId`) &&
                    get(formik, `errors.plantDetails.organizationId`)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={12} md={2.8}>
              <div className="textfield">
                <CustomTextField
                  label="Legal Notice Days"
                  type="number"
                  id="filled-size-small"
                  value={formik.values.plantDetails.legalNoticeDays}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.legalNoticeDays`,
                      Number(value.target.value) || 0
                    )
                  }
                  error={formik.errors?.plantDetails?.legalNoticeDays}
                  helperText={
                    get(formik, `touched.plantDetails.legalNoticeDays`) &&
                    get(formik, `errors.plantDetails.legalNoticeDays`)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={12} md={2.8}>
              <div className="textfield">
                <CustomTextField
                  label="Payment Terms Days"
                  type="number"
                  id="filled-size-small"
                  value={formik.values.plantDetails.paymentTermsDays}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `plantDetails.paymentTermsDays`,
                      Number(value.target.value) || 0
                    )
                  }
                  error={formik.errors?.plantDetails?.paymentTermsDays}
                  helperText={
                    get(formik, `touched.plantDetails.paymentTermsDays`) &&
                    get(formik, `errors.plantDetails.paymentTermsDays`)
                  }
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  )
}

PlantDetails.propTypes = {}

export default PlantDetails
